module.exports = __webpack_public_path__ + "img/ic_16_back.11228ca6.svg";